var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question_content" }, [
    _c("div", { staticClass: "preview_content" }, [
      _c("form", { ref: "answerForm-" + this.currentQuestion.id }, [
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.currentQuestionContent) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }